import { useContext } from "react";
import store from "store";
import { AppContext } from "@/contexts/appContexts";
import { useTranslation } from "next-i18next";
import { IoMdClose } from "react-icons/io";
import { GoHistory } from "react-icons/go";

const INITIAL_SHOW_COUNT = 6;
const SavedWords = ({ savedSearchWords = [], title = "", applySearch }) => {
    const { t } = useTranslation("common");
    const { setSavedSearchWords } = useContext(AppContext);

    const removeSavedSearchWords = (item) => {
        const newSavedSearchWords = item
            ? savedSearchWords.filter((word) => word !== item)
            : [];
        setSavedSearchWords(newSavedSearchWords.slice(0, INITIAL_SHOW_COUNT));
        store.set(
            "savedSearchWords",
            newSavedSearchWords.slice(0, INITIAL_SHOW_COUNT)
        );
    };

    return (
        <div className="flex-1 py-2 bg-blue-100 border-gray-200 sm:pb-4">
            <div className="flex items-center justify-between mb-2">
                <h2 className="text-base font-semibold">{title}</h2>
                <button
                    className="text-[11px]  text-red"
                    onClick={() => removeSavedSearchWords()}
                >
                    {t("Delete All")}
                </button>
            </div>
            <div className="flex flex-col">
                {savedSearchWords
                    .slice(0, INITIAL_SHOW_COUNT)
                    .map((item, index) => (
                        <div
                            key={`${item}-${index}`}
                            className="flex items-center justify-between gap-2 p-2 border-b border-gray-200 cursor-pointer hover:bg-gray-100 last:border-b-0"
                            onClick={() => applySearch(item)}
                        >
                            <div className="flex items-center gap-2">
                                <GoHistory className="size-xs text-[#787878]" />
                                <span className="text-xs text-[#787878]">
                                    {item}
                                </span>
                            </div>
                            <button
                                onClick={(e) => {
                                    e.stopPropagation();
                                    removeSavedSearchWords(item);
                                }}
                                className="p-2 rounded-full hover:bg-gray-200"
                            >
                                <IoMdClose className="size-[9px] text-[#787878]" />
                            </button>
                        </div>
                    ))}
            </div>
        </div>
    );
};

export default SavedWords;
